const SAVE = 'SAVE_COLLECTION';

export function collectionReducer (state = [], action) {
    switch (action.type) {
        case SAVE:
            return action.payload;
        default:
            return state;
    }
}